import React, { useState, useCallback, useMemo } from "react";
import ContentEditable from 'react-contenteditable';
import DraggableDialog from "./modals/adm_usr_add";
import { Paper } from '@material-ui/core';
import RolDialog from './modals/adm_usr_rol'
import axios from 'axios' ;
import { useStyles } from '../../css/muiStyle';
import '../../css/admin.css';
import { AutocompleteS, AlertCompo, TelUpd } from "../../js/components"
import DTable from "../../compo/DTable2";
import Iconn from "@mdi/react";
import { mdiLock, mdiLockOpen } from "@mdi/js";
import FlagComponent from "../../compo/flagman";
import SearchBar from "../../compo/searchBar";


export default function Adm_usr (props){
  const param=props.param
  const Gfunc=require('../../Gfunc')
  const librery=require('../../js/data_table_librery')
  const [data, setData] = useState([]);
  const [type, setType] = useState([]);
  const [search,setSearch]=useState('');
  const [doSearch, setDoSearch] = useState(false);
  const [severity, setSeverity] =useState("info");
  const [open, setOpen] =useState(false);
  const [messageA, setMessageA] = useState('');
  const api = '_usr.php'
  const srv="user"
  const classes = useStyles()
  const filter="&search="+search;
  const [reset, setReset] = useState(false);
  const [flag, setFlag] = useState(false);

   //handle alerts properties
   const handleAlert=useCallback((open,severity,message)=>{
    setOpen(open)
    setSeverity(severity)
    setMessageA(message)
    setTimeout(function(){
      setOpen(false)
    }, 5000);
  },[])

  const fetchType=useCallback(async() => {
    const response = await axios.get(param.urlService + api + '?do=gettyp', { headers: Gfunc.getHeader() });
    if(response.data.err&&response.data.err!=="-1"){
      handleAlert(true,'error',response.data.err)
    }else{
      Gfunc.axiosResponse(response,()=>{
        setType(response.data[1]);  
      })
    }    
  },[param.urlService,Gfunc,handleAlert])

  //update field
  const handleOnEdit=useCallback(async(e,row,att)=>{
    const edt1=e.target.innerHTML
    const edt=Gfunc.DeleteSpace(edt1);
        if(row[att]!==edt){
          const attrib=row[att];
          const response = await librery.axiosEdit(api, row, edt, att) 
          if(response.data.err&&response.data.err!=="-1"){
            handleAlert(true,'error',response.data.err)
          }else
          Gfunc.axiosResponse(response,()=>{row[att]=edt;e.target.innerHTML=edt})
          if(response.data.err) {e.target.innerHTML=attrib}
        }else {e.target.innerHTML=edt}
  },[librery,Gfunc,handleAlert]);


   //update field webtelco
   const handleOnEditWebtelco=useCallback(async(e,row,att)=>{
    const edt1=e.target.innerHTML
    const edt=Gfunc.DeleteSpace(edt1);
       if(edt.length===3) {if(row['webtelco']!==edt){
          const attrib=row[att];
         const response = await librery.axiosEdit(api, row, edt, att) 
          if(response.data.err&&response.data.err!=="-1"){
            handleAlert(true,'error',response.data.err)
          }else
          Gfunc.axiosResponse(response,()=>{row[att]=edt;e.target.innerHTML=edt})
          if(response.data.err) {e.target.innerHTML=attrib}
        }else {e.target.innerHTML=edt}}
        else handleAlert(true,'warning',"Le code doit comporter 3 caractères!")
  },[librery,Gfunc,handleAlert]);

  //fetch user Type handler
const handleOpenType = useCallback(async () => {
    if(type.length===0)
    fetchType()
},[type,fetchType])

const columns =useMemo(
    () => [  
      {
         name: "PSEUDO",
         selector:row=>row.nickname,
         minWidth:"150px !important",
         sortField: "nickname",
         sortable: true,
         cell: (row) => {
            return (
            <ContentEditable
            html={row.nickname}
            name="nickname"
            data-column="item"
            className="content-editable"
            disabled={false} 
            onBlur={e => handleOnEdit(e,row,'nickname')}
          />
             );
           }
      },
      {
        name: "NOM",
        selector:row=>row.nom,
        minWidth:"150px !important",
        sortField: "nom",
        sortable: true,
        cell: (row, column) => {
          return (
          <ContentEditable
          html={row.nom}
          name="nom"
          data-column="item"
          className="content-editable"
          disabled={false} 
          onBlur={e => handleOnEdit(e,row,'nom')}
        />
           );
         }
      },
      {
        name: "CONTACT",
        selector:row=>row.tel,
        minWidth:"120px !important",
        sortField: "tel",
        sortable: true,
        cell: (row, column) => {
          return (
            <div key={`tel-${row.DT_RowId}`}>
                {
                  <TelUpd
                    datein={row.date_in} agentin={row.usrin} dateupd={row.dateUpd} agentupd={row.agentUpd}
                  service={api} action='upd'
                    row={row} att="tel" value={row.tel} id='DT_RowId'
                    handleAlert={handleAlert}
                 />
                }
            </div>
           );
         }
      },
      {        
          name: "Type",
          selector:row=>row.typDesc,
          minWidth:"140px !important",
          sortField: "typDesc",
          sortable: true,
          cell: (row) => { 
              return (
              <AutocompleteS
                  service={api} action={'upd'} 
              defaultValue={row.typDesc} row={row} list={type} 
              id={'typ'} name='typDesc' attr='descr'
              onOpen={handleOpenType} handleAlert={handleAlert}/>
               );
        }
      },
      {
        name: "WEBTELCO",
        selector:row=>row.webtelco,
        minWidth:"100px !important",
        sortField: "webtelco",
        sortable: true,
        cell: (row) => {
          return (
          <ContentEditable
          html={row.webtelco}
          name="webtelco"
          data-column="item"
          className="content-editable"
          onBlur={e => handleOnEditWebtelco(e,row,'id_webtelco',"webtelco")}
        />
           );
         }
      },
      {
        name: "DATE",
        selector:row=>row.date_in,
        minWidth:"110px !important",
        sortField: "date_in",
        sortable: true
      },
      {
        name: "UTILISATEUR",
        selector:row=>row.usrin,
        minWidth:"150px !important",
        sortField: "usrin",
        sortable: true
      },
      {
        right:true,
        sortable: true,
        cell: (row) => {         
          return (
            <div  className="rowGrid" id='twoIcons'>
              <RolDialog row={row} type={type} param={param} />
              <FlagComponent
                title="Désactiver"
                titleFalse="Activer"
                srv={srv}
                row={row}
                att="activ"
                setFlagman={setFlag}
                flagman={flag}
                showAlert={handleAlert}
                //the following props should be sent incase the flag is an icon, cause the flag could be a checkbox
                iconTrue={<Iconn path={mdiLockOpen} color="red" size="18px" />}
                iconFalse={<Iconn path={mdiLock} color="green" size="18px" />}
              />
           </div>
           );
         },
      }  
  ], [handleOnEdit, type, handleOpenType, classes, handleOnEditWebtelco, handleAlert, param, flag]);

  function liveSearch(e, search) {
    //this function is used to detect if we are doing a live search or a normal search
    //if param.liveSearch is true and the characters are above 3 then the search would happen each time a character is clicked
    if (param.liveSearch && search.length > 3) {
      e.preventDefault();
      setSearch(e.target.value);
    } else {
      //else it should lunch the search after the enter key is pushed
      if (e.keyCode === 13) handleSearch();
    }
  }

  function handleSearch() {
    const s = document.getElementById("searchBar");
    setSearch(s.value); //each time we set the search value a search request is sent
  }

  return (
    <div className="content">
      <AlertCompo severity={severity} open={open} setOpen={setOpen} message={messageA} />
      <Paper className={classes.paperBody} elevation={3}>
        <div className='table-header'>
          <div className='button-flex-wrapper'><DraggableDialog type={type} handleOpenType={handleOpenType} callback={() => { setReset(true); }} /></div>
                <div className='search'>
            {doSearch && (
              <SearchBar liveSearch={liveSearch} handleSearch={handleSearch} />
            )}
          </div>
        </div>
        <div>
          <DTable
            cellHeight={21}
             columns={columns}
            api={api}
            service="get"
            filter={filter}
            setDoSearch={(val) => setDoSearch(val)}
            reset={reset} //Optional
            setReset={setReset} //Optional
            //data={data}//optional in exception cases
            //fetch={fetch}
            fixedHeader={true}
            //callback={(data) => setData(data)}
            paginationRowsPerPageOptions={[15, 25, 50, 75, 100]} //optional
          />
        </div>
      </Paper>
    </div>    
  );
}
